var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.398438,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#EFFEFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9134 14.4011C25.7923 14.4135 25.6788 14.4682 25.5916 14.5563L16.8691 23.0668L12.4168 18.4518C12.3668 18.4001 12.3076 18.3592 12.2423 18.3313C12.1771 18.3034 12.1072 18.2891 12.0366 18.2892C11.9661 18.2893 11.8962 18.3038 11.8311 18.3319C11.7659 18.36 11.7067 18.4011 11.6569 18.4529C11.607 18.5047 11.5675 18.5661 11.5406 18.6337C11.5137 18.7013 11.4999 18.7737 11.5 18.8469C11.5001 18.92 11.5141 18.9925 11.5412 19.06C11.5683 19.1275 11.6079 19.1889 11.6579 19.2405L16.4765 24.2331C16.5748 24.3363 16.7081 24.3956 16.848 24.3983C16.9879 24.4011 17.1233 24.3471 17.2253 24.2478L26.3263 15.364C26.4092 15.2851 26.466 15.1812 26.4889 15.0671C26.5117 14.9529 26.4993 14.8341 26.4534 14.7276C26.4075 14.6212 26.3305 14.5324 26.2332 14.4737C26.1359 14.4151 26.0254 14.3897 25.9134 14.4011Z",
    fill: "#0AB39C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickV2);
export default __webpack_public_path__ + "static/media/tick-v2.73b387370c3a5b7afe7528819b13c3db.svg";
export { ForwardRef as ReactComponent };